import React from 'react';

import Header from 'components/Header';
import GlobalRoute from 'components/GlobalRoute';
import Footer from 'components/Footer';

const App = () => {
  return (
    <>
      <Header />
      <GlobalRoute />
      <Footer />
    </>
  );
};

export default App;
